import api, { API } from '@/utils/api.utils';

export interface UserProfile {
  id: number;
  name: string;
  email: string;
  firebase_id: string;
  photoURL?: string;
  role: string;
  
  // Legal Name fields
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  suffix?: string;
  preferred_name?: string;
  former_legal_name?: string;
  
  // Personal Information
  date_of_birth?: string;
  phone_number?: string;
  
  // Address fields
  home_street?: string;
  home_city?: string;
  home_state?: string;
  home_postal_code?: string;
  home_country?: string;
  
  // Mailing address (if different)
  has_separate_mailing_address?: boolean;
  mailing_street?: string;
  mailing_city?: string;
  mailing_state?: string;
  mailing_postal_code?: string;
  mailing_country?: string;
  
  // Gender and Identity
  gender?: string;
  custom_gender?: string;
  pronouns?: string;
  custom_pronouns?: string;
  legal_sex?: string;
  
  // Military Service/Background
  military_status?: string;
  military_enrollment_status?: string;
  
  // Ethnicity
  ethnicities?: Record<string, boolean>;
  latino_nationality?: string;
  
  // Language Information
  first_language?: string;
  first_language_proficiency?: string;
  other_languages?: string[];
  language_proficiencies?: Record<string, string[]>;
  
  // Language Testing
  language_test?: string;
  toefl_scores?: {
    total: { score: string; date: string };
    reading: { score: string; date: string };
    writing: { score: string; date: string };
    speaking: { score: string; date: string };
    listening: { score: string; date: string };
  };
  duolingo_scores?: {
    total: { score: string; date: string };
    literacy: { score: string; date: string };
    comprehension: { score: string; date: string };
    conversation: { score: string; date: string };
    production: { score: string; date: string };
  };
  ielts_scores?: {
    overall: { score: string; date: string };
    reading: { score: string; date: string };
    writing: { score: string; date: string };
    listening: { score: string; date: string };
    speaking: { score: string; date: string };
  };
  pte_scores?: {
    listening: { score: string; date: string };
    reading: { score: string; date: string };
    speaking: { score: string; date: string };
    writing: { score: string; date: string };
    grammar: { score: string; date: string };
    oral_fluency: { score: string; date: string };
    pronunciation: { score: string; date: string };
    spelling: { score: string; date: string };
    vocabulary: { score: string; date: string };
    written_discourse: { score: string; date: string };
  };
  cambridge_qualification?: {
    proficiency_level: string;
    exam_date: string;
  };
  
  // Birth and Citizenship
  birth_country?: string;
  birth_city?: string;
  years_in_us?: number;
  citizenship_status?: string;
  
  // Legacy fields
  graduating_year?: number;
  high_school?: string;
  preferred_language?: string;
  theme_preference?: string;
  user_type?: string;
  discovery_source?: string;
  interests?: string;
  
  created_at?: string;
  updated_at?: string;
}

export const userService = {
  // Get current user profile
  async getCurrentUser(): Promise<UserProfile> {
    const response = await api.get(API.ME);
    return response.data;
  },

  // Update user profile
  async updateProfile(profileData: Partial<UserProfile>): Promise<UserProfile> {
    const response = await api.put(API.ME, profileData);
    return response.data;
  }
};

export default userService;